<template>
  <div>
    <h1>{{ !$store.User ? 'Login' : 'My Account' }}</h1>

    <!-- Unauthed Users -->
    <div v-if="!$store.User">
      <form id="LoginForm" method="POST">
        <label id="test" for="email">Email</label>
        <input name="email" type="email" id="email" autocomplete="username" v-model="email" />
        
        <label for="password">Password</label>
        <input name="password" type="password" id="password" autocomplete="current-password" v-model="password"/>
        <button type="submit" value="login" @click="performLogin">Login</button>
      </form>
      <button @click="resetPassword">I Forgot My Password</button>
    </div>

    <!-- Already Logged-In Users -->
    <div v-if="$store.User">
      <div>
        <p v-if="!editMode"><b>Name</b> {{ $store.User.fname}} {{$store.User.lname}}</p>
        <p v-if="editMode" >
          <label>First Name</label>
          <input type="text" v-model="editfname" :placeholder="$store.User.fname" />
        </p>
        <p v-if="editMode">
          <label>Last Name</label>
          <input type="text" v-model="editlname" :placeholder="$store.User.lname" />
        </p>
      </div>
      
      <div>
        <p v-if="!editMode"><b>Email</b> {{$store.User.email}}</p>
        <p v-if="editMode"><label>Email</label> <input type="email" v-model="editemail" v-if="editMode" :placeholder="$store.User.email" /></p>
      </div>
      
      <div v-if="!editMode">
        <p><b>Created</b> {{$store.User.created | date}}</p>
        <p><b>Last Login</b> {{ $store.User.last_login | date }}</p>
        <p><b>Account Type</b> {{$store.User.admin ? 'Administrator' : 'Salesperson'}}</p>
      </div>
      
      <div v-if="editMode">
        <p><b>Change Password</b> Leave Inputs Blank to Retain Password</p>
        <input type="password" v-model="pw1"/>
        <input type="password" v-model="pw2"/>
      </div>
      
      <p><button @click="toggleEdit">{{(editMode) ? 'Save' : 'Edit Account'}}</button> <button v-if="editMode" @click="cancelEdit">Cancel</button></p>
      
      <hr>
      <button @click="signOut">Sign Out</button>

    </div>
  </div>
</template>

<script>
// Import Helpers
import { RetrieveAuthToken, CallApi } from "../Utilities.js";
import { store } from "../store";
import router from "../router";

// Module Code
export default {
  props: ["action"],
  data: function() {
    return {
      email: "",
      password: "",
      editMode: 0,
      editfname : "",
      editlname : "",
      editemail : "",
      pw1 : "", pw2 : ""
    };
  },

  methods: {
    cancelEdit: function() {
        // Flag We Are No Longer Editting
        this.pw1 = ""
        this.pw2 = ""
        this.editemail = ""
        this.editfname = ""
        this.editlname = ""
        this.editMode = 0
    },
    toggleEdit: async function() {
      // If we're In View Mode, Change to Edit Mode
      if (this.editMode == 0) {
        this.editMode = 1
      }


      // If We're In Edit Mode Already, Push Data to Server
      else {
        // If Passwords Are Set, Confirm they Match
        if ( ((this.pw1 !== "") || (this.pw2 !== "") ) && (this.pw1 != this.pw2) ) {
          alert("Passwords Do Not Match!")
          return
        }

        // Build Changed Fields List
        const AccountChanges = {}
        if (this.editfname !== "") AccountChanges.fname = this.editfname
        if (this.editlname !== "") AccountChanges.lname = this.editlname
        if (this.editemail !== "") AccountChanges.email = this.editemail
        if (this.pw1 !== "") AccountChanges.password = this.pw1

        // If Password Entered, Check Both Match
        store.User = (await CallApi("POST", "/my-account", AccountChanges)).user

        // Flag We Are No Longer Editting
        this.pw1 = ""
        this.pw2 = ""
        this.editemail = ""
        this.editfname = ""
        this.editlname = ""
        this.editMode = 0
      }
    },
    resetPassword: async function() {
      const email = prompt("Enter your Account Email Addess");
      await CallApi("POST", "/reset-pw", { email });
    },

    signOut: function() {
      localStorage.removeItem("user");
      store.User = null;
      this.$forceUpdate();
    },
    
    performLogin: async function(e) {
      e.preventDefault();
      await RetrieveAuthToken(this.email, this.password);
      router.push({ name: "dashboard" });
    }
  }
};
</script>